import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRouteUser = ({ children }) => {
    const auth = useAuth();

    if (!auth) return null;

    const { user, role } = auth;

    if (!user) return <Navigate to="/signin" replace />;

    // Barbers and shop owners have their own dashboards — redirect them away
    if (role === 'shop_owner') return <Navigate to="/" replace />;
    if (role === 'barber')     return <Navigate to="/" replace />;

    return children;
};

export default ProtectedRouteUser;